import ApiClient from './ApiClient';

class TeamChatApi extends ApiClient {
  constructor() {
    super('team_chat', { accountScoped: true });
  }
}

export default new TeamChatApi();
